{
  "level": "bs0405mv",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:bs0405mv",
    "objects": "AREAS.E3:bs0405mv.e3",
    "mesh": "TREES.E3:bs0405mv.e3"
  },
  "spawn_point": {
    "position": [
      0.0,
      0.0,
      0.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      0.0,
      100.0,
      0.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      0.0,
      0.0,
      0.0
    ],
    "bbox_max": [
      0.0,
      0.0,
      0.0
    ],
    "vertex_count": 0,
    "vertices": []
  },
  "sectors": [
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 1.0,
      "bbox_min": [
        -10.0,
        -10.0,
        -1.0
      ],
      "bbox_max": [
        10.0,
        10.0,
        -1.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 5453,
      "centroid": [
        -2902.0,
        -4247.66796875,
        1058.3118896484375
      ],
      "bbox_min": [
        -2910.0,
        -4247.66796875,
        1052.623779296875
      ],
      "bbox_max": [
        -2894.0,
        -4247.66796875,
        1064.0
      ],
      "dimensions_source": {
        "span_x": 16.0,
        "span_y": 0.0,
        "height_z": 11.376220703125,
        "door_width": 16.0,
        "door_depth": 0.0,
        "leaf_depth": 0.0,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          1.0,
          0.0
        ]
      },
      "vertices": [
        [
          -2910.0,
          -4247.66796875,
          1052.623779296875
        ],
        [
          -2910.0,
          -4247.66796875,
          1064.0
        ],
        [
          -2894.0,
          -4247.66796875,
          1064.0
        ],
        [
          -2894.0,
          -4247.66796875,
          1052.623779296875
        ]
      ],
      "plane_distance": 4247.668
    }
  ],
  "tutorial_messages": []
}